import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Flip } from 'gsap/Flip';
import { Observer } from 'gsap/Observer';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

let registered = false;

/** Register all GSAP plugins exactly once and set global defaults. */
export function registerGsap(): void {
  if (registered) return;
  gsap.registerPlugin(ScrollTrigger, Flip, Observer, ScrollToPlugin);
  gsap.defaults({ ease: 'power3.out', duration: 0.8 });
  // Avoid janky refreshes when the mobile URL bar shows/hides.
  ScrollTrigger.config({ ignoreMobileResize: true });
  gsap.ticker.lagSmoothing(1000, 16);
  registered = true;
}

export const EASE = {
  premium: 'power3.out',
  emphasis: 'power4.out',
  expo: 'expo.out',
  soft: 'sine.inOut',
} as const;

export { gsap, ScrollTrigger, Flip, Observer };
